export default __webpack_public_path__ + "static/media/3.5f8ea879.svg";